module.exports = __webpack_public_path__ + "img/pride.03b256d5.png";